/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DataRefreshIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Data Refresh',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18.5918,15.18555c-.39746-.12988-.81738.08691-.94629.47949-.44629,1.36719-1.71094,2.28516-3.14551,2.28516-1.07446,0-2.03967-.52039-2.64844-1.34204l.16016.05786c.32324.11816.68359-.05078.7998-.37598.11719-.32422-.05078-.68262-.37598-.7998l-1.81836-.65625c-.1582-.05664-.33398-.04785-.48535.02637-.15137.07324-.26758.20508-.32031.36621l-.62891,1.90723c-.10742.32715.07031.68066.39844.78906.06445.02148.13086.03125.19531.03125.2627,0,.50684-.16602.59375-.42969l.09094-.27576c.8656,1.34436,2.36633,2.20154,4.03894,2.20154,2.08594,0,3.92285-1.33398,4.57129-3.31836.12891-.39453-.08594-.81738-.47949-.94629Z"
      fill="currentColor"
    />
    <path
      d="M19.31836,11.05371c-.32617-.10938-.68066.07129-.78906.39844l-.0647.19653c-.88135-1.28101-2.35645-2.09888-3.9646-2.09888-2.10352,0-3.94531,1.34863-4.58301,3.35547-.125.39551.09277.81738.4873.94238.39941.12988.81738-.09375.94238-.4873.43848-1.38184,1.70605-2.31055,3.15332-2.31055,1.06909,0,2.05078.52832,2.66284,1.35974l-.27417-.099c-.32031-.11523-.68262.05176-.7998.37598s.05078.68262.37598.7998l1.81836.65625c.06836.02441.14062.03711.21191.03711.09375,0,.1875-.02148.27344-.06348.15234-.07324.26758-.20605.32031-.36621l.62793-1.90723c.10742-.32812-.07031-.68066-.39844-.78906Z"
      fill="currentColor"
    />
    <path
      d="M8.17969,10.92676c-3.16992-.26465-4.6123-1.12012-4.67969-1.42676v-3.27551c1.52979.84216,4.02393,1.27551,6.5,1.27551s4.97021-.43335,6.5-1.27551v1.49915c0,.41406.33594.75.75.75s.75-.33594.75-.75v-3.16309c0-.04077-.01697-.07593-.02319-.11499.00781-.06519.02319-.12842.02319-.19556,0-2.13379-4.02441-3.25-8-3.25S2,2.11621,2,4.25c0,.06714.01538.13037.02319.19556-.00623.03906-.02319.07422-.02319.11499v9.93945c0,1.77637,2.92773,2.49121,4.67285,2.75879.03906.00586.07715.00879.11523.00879.36426,0,.68359-.26562.74023-.63574.0625-.41016-.21777-.79297-.62695-.85547-2.46484-.37891-3.35645-1.07227-3.40137-1.27637v-3.14429c1.48389.73853,3.65857.9906,4.55469,1.06519.02148.00195.04199.00293.06348.00293.38574,0,.71387-.2959.74609-.6875.03516-.41309-.27148-.77539-.68457-.80957ZM10,2.5c4.28809,0,6.5,1.22656,6.5,1.75s-2.21191,1.75-6.5,1.75-6.5-1.22656-6.5-1.75,2.21191-1.75,6.5-1.75Z"
      fill="currentColor"
    />
  </svg>`;
};
